var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import Match from "../common/sportsGrid/Match";
import { injectIntl, defineMessages } from "react-intl";
import { cssClassMap } from "../../../constants/SportCssMap";
import { Link } from "react-router-dom";
import { winWithoutDraw } from "../common/sportsGrid/matchType";
var messages = defineMessages({
    grid_w1: {
        id: "grid.w1",
        defaultMessage: "П1"
    },
    grid_x: {
        id: "grid.x",
        defaultMessage: "X"
    },
    grid_w2: {
        id: "grid.w2",
        defaultMessage: "П2"
    }
});
var Sport = function (props) {
    var sport = props.sport, matches = props.matches, section = props.section, gridLocalization = props.gridLocalization, intl = props.intl, eventCount = props.eventCount;
    var sportId = sport.get("id");
    var renderMatches = [];
    matches.map(function (match) {
        renderMatches.push(_jsx(Match, { id: match.get("id"), first: false, section: section, gridLocalization: gridLocalization }, match.get("id")));
    });
    return (_jsxs("div", __assign({ className: "section" }, { children: [_jsxs(Link, __assign({ to: "/sport/" + sportId, className: "title ".concat(cssClassMap[sportId]) }, { children: [_jsxs("div", __assign({ className: "title__name" }, { children: [sport.get("name"), _jsx("span", __assign({ className: "title__badge" }, { children: eventCount }))] })), winWithoutDraw.find(function (m) { return m === sportId; }) ? (_jsxs("div", __assign({ className: "title__rates" }, { children: [_jsx("div", __assign({ className: "title__rate" }, { children: intl.formatMessage(messages.grid_w1) })), _jsx("div", __assign({ className: "title__rate" }, { children: intl.formatMessage(messages.grid_w2) }))] }))) : (_jsxs("div", __assign({ className: "title__rates" }, { children: [_jsx("div", __assign({ className: "title__rate" }, { children: intl.formatMessage(messages.grid_w1) })), _jsx("div", __assign({ className: "title__rate" }, { children: intl.formatMessage(messages.grid_x) })), _jsx("div", __assign({ className: "title__rate" }, { children: intl.formatMessage(messages.grid_w2) }))] })))] })), _jsx("div", __assign({ className: "items" }, { children: renderMatches }))] })));
};
Sport.propTypes = {
    gridLocalization: PropTypes.object.isRequired,
    sport: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    eventCount: PropTypes.number.isRequired
};
export default injectIntl(Sport);



// WEBPACK FOOTER //
// ./src/components/grid/popular/Sport.jsx